export const dealStatus = {
  lost: { id: 'lost', label: 'Lost', color: '#4e5d7e' },
  offTrack: { id: 'offTrack', label: 'Off Track', color: '#fb6c6a' },
  onTrack: { id: 'onTrack', label: 'On Track', color: '#4de578' },
  pushed: { id: 'pushed', label: 'Pushed', color: '#f88a4b' },
  stalled: { id: 'stalled', label: 'Stalled', color: '#f8d57a' },
  won: { id: 'won', label: 'Won', color: '#4de578' },
}
